/*
 * cl-ship-date.js (BUYBOX lane, 2026-10-06)
 * Honest ship-date promise, computed client-side in America/Chicago.
 * - Stock: "Ships by <date> - arrives about <date> with Economy (sooner with faster shipping at checkout)"
 * - Custom/imprinted: "Proof sent by <date> - ships 3-5 business days after you approve it"
 * Dates skip weekends and: New Year's Day, MLK Day, Presidents Day, Memorial Day, Juneteenth,
 * Independence Day, Labor Day, Columbus Day, Veterans Day, Thanksgiving + the Friday after,
 * Dec 24, Dec 25, Dec 31 (plant closures per Joe, 2026-10-06).
 * Never promises same-day shipping (only ~8% of stock orders ship same day).
 * Idempotent: safe to include this script tag more than once on a page.
 */
(function () {
  'use strict';
  if (window.__CL_SHIPDATE_INIT) return;
  window.__CL_SHIPDATE_INIT = true;

  // Must match CUTOFF_HOUR_CT in scripts/analyze.mjs and scripts/ships-today-feed.mjs.
  var CUTOFF_HOUR_CT = 14; // 2:00 PM Central

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function chicagoYMD(date) {
    var fmt = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Chicago', year: 'numeric', month: '2-digit', day: '2-digit'
    });
    var parts = fmt.formatToParts(date).reduce(function (a, p) { a[p.type] = p.value; return a; }, {});
    return { y: +parts.year, m: +parts.month, d: +parts.day };
  }

  // Same as chicagoYMD but with clock time too (for the ships-today cutoff countdown - job
  // 2026-10-07). Kept separate since most of this file only ever needs the date.
  var CHI_HMS_FMT = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Chicago', year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23',
  });
  function chicagoNow(date) {
    var parts = CHI_HMS_FMT.formatToParts(date).reduce(function (a, p) { a[p.type] = p.value; return a; }, {});
    return { y: +parts.year, m: +parts.month, d: +parts.day, h: +parts.hour, min: +parts.minute, s: +parts.second };
  }

  function utcDate(y, m, d) { return new Date(Date.UTC(y, m - 1, d)); }
  function addDaysUTC(dt, n) { var r = new Date(dt.getTime()); r.setUTCDate(r.getUTCDate() + n); return r; }
  function dstr(dt) { return dt.getUTCFullYear() + '-' + pad(dt.getUTCMonth() + 1) + '-' + pad(dt.getUTCDate()); }

  function fmtShort(dt) {
    return new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', weekday: 'short', month: 'short', day: 'numeric' }).format(dt);
  }

  // weekday: 0=Sun..6=Sat. n = 1st, 2nd, 3rd, 4th occurrence in the month.
  function nthWeekdayOfMonth(year, month, weekday, n) {
    var first = utcDate(year, month, 1);
    var offset = (weekday - first.getUTCDay() + 7) % 7;
    return utcDate(year, month, 1 + offset + (n - 1) * 7);
  }
  function lastWeekdayOfMonth(year, month, weekday) {
    var lastDay = addDaysUTC(utcDate(year, month + 1, 1), -1);
    var back = (lastDay.getUTCDay() - weekday + 7) % 7;
    return addDaysUTC(lastDay, -back);
  }

  function holidaysForYear(year) {
    var set = {};
    function add(dt) { set[dstr(dt)] = true; }
    add(utcDate(year, 1, 1));                      // New Year's Day
    add(nthWeekdayOfMonth(year, 1, 1, 3));          // MLK Day - 3rd Mon Jan
    add(nthWeekdayOfMonth(year, 2, 1, 3));          // Presidents Day - 3rd Mon Feb
    add(lastWeekdayOfMonth(year, 5, 1));            // Memorial Day - last Mon May
    add(utcDate(year, 6, 19));                      // Juneteenth
    add(utcDate(year, 7, 4));                       // Independence Day
    add(nthWeekdayOfMonth(year, 9, 1, 1));          // Labor Day - 1st Mon Sep
    add(nthWeekdayOfMonth(year, 10, 1, 2));         // Columbus Day - 2nd Mon Oct
    add(utcDate(year, 11, 11));                     // Veterans Day
    var thanksgiving = nthWeekdayOfMonth(year, 11, 4, 4); // 4th Thu Nov
    add(thanksgiving);
    add(addDaysUTC(thanksgiving, 1));               // day after Thanksgiving
    add(utcDate(year, 12, 24));
    add(utcDate(year, 12, 25));
    add(utcDate(year, 12, 31));
    return set;
  }

  function holidaySetSpanning(y1, y2) {
    var a = holidaysForYear(y1), b = holidaysForYear(y2);
    for (var k in b) { if (Object.prototype.hasOwnProperty.call(b, k)) a[k] = true; }
    return a;
  }

  function isBizDay(dt, holset) {
    var dow = dt.getUTCDay();
    if (dow === 0 || dow === 6) return false;
    return !holset[dstr(dt)];
  }

  function addBizDays(startDt, n, holset) {
    var cur = new Date(startDt.getTime());
    var count = 0;
    while (count < n) {
      cur = addDaysUTC(cur, 1);
      if (isBizDay(cur, holset)) count++;
    }
    return cur;
  }

  function isCustom(type, tags, templateSuffix, collections, titles) {
    type = (type || '').toLowerCase();
    if (type.indexOf('custom') !== -1) return true;
    tags = tags || [];
    for (var i = 0; i < tags.length; i++) {
      var t = ('' + tags[i]).toLowerCase();
      if (t.indexOf('custom') !== -1 || t.indexOf('imprint') !== -1) return true;
    }
    if (templateSuffix === 'custom_labels' || templateSuffix === 'custom-product') return true;
    collections = collections || [];
    for (var j = 0; j < collections.length; j++) {
      var c = ('' + collections[j]).toLowerCase();
      if (c.indexOf('custom') !== -1 || c.indexOf('imprint') !== -1) return true;
    }
    // /cart.js line items don't expose tags/collections, only product_type and titles - fall back
    // to the same title heuristic the cx-research post-purchase audit used for "custom vs stock".
    titles = titles || [];
    for (var k = 0; k < titles.length; k++) {
      var tt = ('' + titles[k]).toLowerCase();
      if (tt.indexOf('custom') !== -1 || tt.indexOf('imprint') !== -1) return true;
    }
    return false;
  }

  function stockMessage(today, holset, slower) {
    // The ship-by date is about our own fulfillment (true regardless of destination). The arrival
    // estimate is specifically US Economy ground transit - the shipping policy quotes DHL and a
    // different timeline for international orders, so this is qualified rather than shown as a
    // universal promise (a destination is not known yet on the product/cart page, before checkout).
    var shipBy = addBizDays(today, slower ? 2 : 1, holset);
    var arrive = addBizDays(shipBy, 5, holset);
    return (slower ? 'Usually ships by ' : 'Ships by ') + fmtShort(shipBy) +
      ' · arrives about ' + fmtShort(arrive) + ' to US addresses with Economy' +
      ' (sooner with faster shipping at checkout; international timing varies)';
  }
  function customMessage(today, holset) {
    var proofBy = addBizDays(today, 1, holset);
    return 'Proof sent by ' + fmtShort(proofBy) + ' · ships 3–5 business days after you approve it';
  }

  function setText(el, text, custom, countdown) {
    // Equality guard: a MutationObserver watches document.body (to catch AJAX-rendered mini-cart /
    // GemPages content), and every DOM write re-fires it. Skipping no-op writes keeps that from
    // looping forever and from re-triggering the /cart.js fetch on every observer tick. The
    // countdown's text changes every minute on its own (see the 30s poll below), so this guard
    // naturally lets it through whenever the remaining time actually ticks over.
    if (el.textContent === text && el.getAttribute('data-cl-filled') === '1') return;
    el.textContent = text;
    el.classList.toggle('cl-shipdate--custom', !!custom);
    el.classList.toggle('cl-shipdate--stock', !custom && !countdown);
    el.classList.toggle('cl-shipdate--countdown', !!countdown);
    el.setAttribute('data-cl-filled', '1');
  }

  var ATC_BTN_SEL = 'button[name="add"], [data-cls-atc], button[type="submit"], input[type="submit"]';

  // Generic client-side-variant-switch reactivity: whatever theme/page-builder is driving the Add
  // to Cart button (native theme, GemPages, or spec-pro's own color-swatch JS), it has to toggle
  // something observable on THAT button when the selected variant becomes unsellable - at minimum
  // `disabled`, often also `aria-disabled` or its visible text ("Sold Out"). Watching the button
  // itself means we don't need to understand any template's own variant-selector markup (spec-pro's
  // swatches, a native dropdown, GemPages' own JS) to stay in sync with it.
  function wireButtonReactivity(shipEl, btn, blocked) {
    // `blocked` (pre-order with no measured timeline at all, OR this run's suppress-the-generic-
    // line decision) can both ENGAGE and LIFT between calls - pre-order is permanent in practice,
    // but suppression is not (the ships-today countdown can make an otherwise-suppressed line show
    // again, then stop being eligible later and need to go back to suppressed). Always assign
    // (not just "turn on") so a later call that no longer needs it is able to clear it, not just
    // the reverse - the previous version only ever set this to true and never back to false, which
    // left a countdown stuck hidden after it stopped being eligible-and-then-eligible-again
    // (caught in Codex review).
    shipEl.__clBlocked = !!blocked;
    if (!btn || shipEl.__clWired) return;
    shipEl.__clWired = true;
    function sync() {
      var disabled = btn.disabled || btn.getAttribute('aria-disabled') === 'true';
      shipEl.hidden = disabled || !!shipEl.__clBlocked;
    }
    var mo2 = new MutationObserver(sync);
    mo2.observe(btn, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
    // Not calling sync() synchronously here: on some GemPages templates the Add to Cart button
    // starts enabled in the markup and only gets `disabled` added by the template's own
    // variant-init JS a moment later, so reading it THIS instant could see "not disabled yet" and
    // un-hide a promise the server-rendered payload already correctly marked unavailable. Deferring
    // one frame gives that synchronous/microtask init code a chance to finish first - covering both
    // that race AND the opposite one (a button that was already disabled before we got here, which
    // the MutationObserver alone would never see since the attribute change happened before we
    // started observing).
    if (typeof requestAnimationFrame === 'function') requestAnimationFrame(sync);
    else setTimeout(sync, 0);
  }

  // Minutes left before the 2pm Central cutoff, on a business day, right now - or null if it's
  // already past cutoff, or today isn't a business day (job 2026-10-07: "ships today" countdown).
  function minutesUntilCutoff(holset) {
    var n = chicagoNow(new Date());
    var today = utcDate(n.y, n.m, n.d);
    if (!isBizDay(today, holset)) return null;
    var nowMin = n.h * 60 + n.min + n.s / 60;
    var cutoffMin = CUTOFF_HOUR_CT * 60;
    if (nowMin >= cutoffMin) return null;
    return cutoffMin - nowMin;
  }

  function countdownMessage(minutesLeft) {
    var hrs = Math.floor(minutesLeft / 60);
    var mins = Math.round(minutesLeft - hrs * 60);
    if (mins === 60) { hrs += 1; mins = 0; } // rounding carry
    // In the last ~30s before cutoff, rounding mins down to 0 would read as "Order in the next 0
    // min" - still true (time remains), but reads like there's none left. Caught in Codex review.
    var left = hrs === 0 && mins === 0 ? 'less than 1 min' : (hrs > 0 ? hrs + ' hr ' : '') + mins + ' min';
    return 'Order in the next ' + left + ' and it ships today. Need it sooner? Choose 2-Day or Next Day Air at checkout.';
  }

  // Reads the currently-selected variant id from whatever form this ship-date line lives in -
  // the standard Shopify pattern (native theme, GemPages, and spec-pro's own `data-cls-id` hidden
  // input all use a `name="id"` field) regardless of how that template's own JS maintains it.
  function getSelectedVariantId(form) {
    if (!form) return null;
    var input = form.querySelector('[name="id"]');
    return input && input.value ? String(input.value) : null;
  }

  function messageFor(p, today, holset, variantId) {
    // "Ships today" countdown takes priority over the generic stock/custom line (even on
    // spec-pro, which otherwise suppresses that generic line - this is a different, more urgent,
    // more specific signal, not the thing being suppressed) whenever the SELECTED variant has
    // been nightly-computed as eligible (scripts/ships-today-feed.mjs) and it's currently before
    // the cutoff on a business day.
    var ve = variantId != null && p.variantEligibility ? p.variantEligibility[variantId] : null;
    if (ve && ve.eligible === true) {
      var minutesLeft = minutesUntilCutoff(holset);
      if (minutesLeft != null) return { text: countdownMessage(minutesLeft), custom: false, countdown: true };
    }
    var custom = isCustom(p.type, p.tags, p.templateSuffix, p.collections);
    return { text: custom ? customMessage(today, holset) : stockMessage(today, holset), custom: custom, countdown: false };
  }

  // Applies one product's payload to one element it actually belongs to (matched by
  // data-cl-product-id, or the page's main product for an untagged/legacy element). Multiple
  // distinct products can be on one page at once (a quick-view modal, a bundle/upsell widget), so
  // this is per-element, never "the one global payload wins everywhere".
  function applyProductPromise(el, p, today, holset) {
    var preOrder = p.templateSuffix === 'pre-order';
    var ownForm = el.closest ? el.closest('form') : null;
    var variantId = getSelectedVariantId(ownForm);
    var m = messageFor(p, today, holset, variantId);
    // Generic line is suppressed in favor of this page's own curated copy (spec-pro) - but the
    // ships-today countdown (messageFor already checked this) is a different, more urgent signal
    // and overrides that suppression; plain "nothing eligible right now" does not. Recomputed
    // fresh on every call (not just once) - eligibility can flip from one run to the next with no
    // button mutation in between at all, so the hidden state has to be re-applied every time, not
    // only when wiring a button for the first time (that bug previously left a countdown stuck
    // hidden after going eligible -> ineligible -> eligible again).
    var suppressHide = !!(p.suppressed && !m.countdown);
    if (!suppressHide) setText(el, m.text, m.custom, m.countdown);
    // Prefer the specific button this element was created next to (set at auto-injection time,
    // when a form has more than one Add to Cart button instance - desktop/mobile duplicates);
    // only fall back to "first button in the form" for explicitly-placed divs (spec-pro, native
    // templates) where there is just the one button anyway.
    var btn = el.__clOwnButton || (ownForm ? ownForm.querySelector(ATC_BTN_SEL) : null);
    // Availability: read the CURRENT button state live, the same source sync() uses below, not
    // the page-LOAD snapshot (p.available) - using the stale snapshot on every periodic/variant-
    // change re-run was fighting with sync()'s own live reads, hiding an available variant that
    // loaded sold-out or un-hiding one that loaded available but was since switched away from
    // (caught in Codex review). The snapshot is only a fallback for the rare case of no button at
    // all yet to read.
    var disabled = btn ? (btn.disabled || btn.getAttribute('aria-disabled') === 'true') : (p.available === false);
    el.hidden = suppressHide || preOrder || disabled;
    wireButtonReactivity(el, btn, preOrder || suppressHide);
  }

  // Returns whether the MAIN product specifically got a server-rendered element filled - not
  // "whether any element on the page was handled". A bundle/upsell widget's own correctly-tagged
  // element must not suppress auto-injection of the main product's line (they're unrelated
  // products); only the main product's own coverage should do that.
  function fillTaggedPdpElements(map, mainId, today, holset) {
    var mainHandled = false;
    document.querySelectorAll('[data-cl-shipdate]').forEach(function (el) {
      var id = el.getAttribute('data-cl-product-id');
      if (id) {
        // Tagged for a specific product. If that product's payload never arrived (e.g. a
        // quick-view modal injected this element via AJAX for a product that was not the one
        // rendered at page load - inline <script> payloads in AJAX-inserted HTML never execute),
        // do NOT fall back to the main product's data: a custom/pre-order product could end up
        // showing a stock promise. Leave it untouched (hidden) rather than guess wrong.
        if (!map[id]) { el.hidden = true; return; }
        if (String(id) === String(mainId)) mainHandled = true;
        applyProductPromise(el, map[id], today, holset);
        return;
      }
      // Untagged/legacy element with no product id at all: only safe fallback is the page's own
      // product.
      if (mainId == null || !map[mainId]) return;
      mainHandled = true;
      applyProductPromise(el, map[mainId], today, holset);
    });
    return mainHandled;
  }

  // GemPages auto-injection path (no server-rendered [data-cl-shipdate] anywhere on the page):
  // only ever targets the page's OWN product/form, never a second product that might show up in
  // the map from a quick-view or bundle widget elsewhere on the page.
  function autoInjectPdp(mainId, p, today, holset) {
    if (p.templateSuffix === 'contact') return;
    // A page that explicitly asked to suppress the generic promise (e.g. spec-pro's curated
    // products, which show their own measured per-family ship-time line instead) means no
    // fallback injection either, even though no [data-cl-shipdate] element exists to find.
    if (p.suppressed) return;
    var available = p.available !== false;
    var preOrder = p.templateSuffix === 'pre-order';
    // GemPages templates commonly tag the product form itself with data-productid - prefer a form
    // that actually matches the main product over blindly taking the first /cart/add form on the
    // page (which could belong to a preceding upsell/bundle widget instead). Falls back to "first
    // match" only when no form on the page carries that attribute at all.
    var form = document.querySelector('form[action*="/cart/add"][data-productid="' + mainId + '"]') ||
      (document.querySelector('form[action*="/cart/add"][data-productid]') ? null :
        document.querySelector('form[action*="/cart/add"]'));
    if (!form) return;
    var m = messageFor(p, today, holset, getSelectedVariantId(form));
    // Still create (hidden) elements even when the page-load snapshot says unavailable - the
    // customer may pick a different, in-stock variant/option afterwards with no reload, and
    // wireButtonReactivity() is what keeps the line in sync with that from here on. preOrder is
    // different: it's permanent regardless of variant, so it's never un-hidden.
    // Insert one line per Add to Cart button, not just the first: some GemPages templates (e.g. the
    // shared dot-family one) render separate desktop/mobile button instances in the same form, each
    // shown/hidden by breakpoint, and a single shared line could land next to the hidden one.
    var btns = form.querySelectorAll(ATC_BTN_SEL);
    if (!btns.length) {
      var lone = document.createElement('div');
      lone.className = 'cl-shipdate cl-shipdate--injected';
      lone.setAttribute('data-cl-shipdate', '');
      lone.setAttribute('aria-live', 'polite');
      setText(lone, m.text, m.custom, m.countdown);
      lone.hidden = !available || preOrder;
      if (preOrder) lone.__clBlocked = true;
      form.appendChild(lone);
      return;
    }
    btns.forEach(function (btn) {
      var div = document.createElement('div');
      div.className = 'cl-shipdate cl-shipdate--injected';
      div.setAttribute('data-cl-shipdate', '');
      div.setAttribute('aria-live', 'polite');
      setText(div, m.text, m.custom, m.countdown);
      div.hidden = !available || preOrder; // corrected by wireButtonReactivity's sync(), unless blocked
      // Remembered so later re-runs (applyProductPromise, once this div is picked up as an
      // ordinary tagged/untagged element) check THIS button specifically, not just "the first
      // button in the form" - a form with separate desktop/mobile button instances (the shared
      // dot-family GemPages template) would otherwise have its mobile line's visibility driven by
      // the desktop button's state and vice versa (caught in Codex review).
      div.__clOwnButton = btn;
      if (btn.parentNode) btn.parentNode.insertBefore(div, btn.nextSibling);
      wireButtonReactivity(div, btn, preOrder);
    });
  }

  function fillPdp(today, holset) {
    var map = window.__clShipDateMap;
    if (!map) return;
    var mainId = window.__clShipDateMainId;
    if (fillTaggedPdpElements(map, mainId, today, holset)) return; // spec-pro / native already cover it
    if (mainId == null || !map[mainId]) return;
    autoInjectPdp(mainId, map[mainId], today, holset);
  }

  function cartAnchors() {
    var roots = [];
    var drawer = document.getElementById('mini-cart');
    if (drawer) roots.push(drawer);
    document.querySelectorAll('.cart-recap, form[action$="/cart"]').forEach(function (f) {
      if (roots.indexOf(f) === -1) roots.push(f);
    });
    var out = [];
    roots.forEach(function (root) {
      // The Checkout button (when settings.cart_show_checkout_button is on) sits in a flex row
      // next to "View Cart" (`.button-group`/`.mini-cart__button-container`/`.cart-recap__checkout`
      // - a card__section wrapper in the full cart). Anchor on that ROW and insert our line as a
      // sibling AFTER the whole row, never as a third flex child inside it (squeezes/wraps it).
      var btn = root.querySelector('button[name="checkout"]');
      var row = btn
        ? (btn.closest('.button-group, .mini-cart__button-container, .cart-recap__checkout, .card__section') || btn.parentNode)
        : root.querySelector('.mini-cart__button-container, .cart-recap__checkout, .button-group, .card__section');
      if (row && row.parentNode) out.push({ root: root, after: row });
    });
    return out;
  }

  function injectCartShipDate(text, custom) {
    cartAnchors().forEach(function (a) {
      var div = a.root.__clShipDateEl;
      if (!div || !div.isConnected) {
        div = document.createElement('div');
        div.className = 'cl-shipdate cl-shipdate--cart';
        div.setAttribute('aria-live', 'polite');
        a.after.parentNode.insertBefore(div, a.after.nextSibling);
        a.root.__clShipDateEl = div;
      }
      div.hidden = false;
      setText(div, text, custom);
    });
  }

  function isPreOrderItem(type, title) {
    type = (type || '').toLowerCase();
    title = (title || '').toLowerCase();
    return type.indexOf('pre-order') !== -1 || type.indexOf('preorder') !== -1 ||
      title.indexOf('pre-order') !== -1 || title.indexOf('preorder') !== -1;
  }

  function hideCartShipDate() {
    cartAnchors().forEach(function (a) {
      if (a.root.__clShipDateEl) a.root.__clShipDateEl.hidden = true;
    });
  }

  // /cart.js line items don't expose tags or collections, only product_type/title (Shopify's AJAX
  // Cart API is intentionally minimal). /products/<handle>.js does include tags, so look each
  // distinct line item's product up to classify it properly instead of relying on title/type
  // alone. Small, cached, and capped - carts are normally a handful of distinct products.
  var productFieldCache = {};
  function fetchProductFields(handle) {
    if (!handle) return Promise.resolve(null);
    if (productFieldCache[handle]) return productFieldCache[handle];
    var p = fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (pr) { return pr ? { tags: pr.tags || [], type: pr.type || pr.product_type || '' } : null; })
      .catch(function () { return null; });
    productFieldCache[handle] = p;
    return p;
  }

  var cartFetching = false;
  var cartRefreshPending = false;
  function refreshCart(today, holset) {
    if (!cartAnchors().length) return;
    if (cartFetching) { cartRefreshPending = true; return; } // a newer cart state arrived mid-fetch
    cartFetching = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        // A non-OK response (this store's own per-IP cart-limit 429s are a known, documented
        // issue - cx-research 01-mobile-speed) or a payload missing `items` must NOT be treated as
        // "empty cart, show the stock promise": leave whatever was already displayed alone rather
        // than guess.
        if (!cart || !Array.isArray(cart.items)) return;
        var items = cart.items;
        var handles = items.map(function (it) { return it.handle; }).filter(Boolean);
        var uniqueHandles = handles.filter(function (h, i) { return handles.indexOf(h) === i; });
        return Promise.all(uniqueHandles.map(fetchProductFields)).then(function (fieldsList) {
          var byHandle = {};
          uniqueHandles.forEach(function (h, i) { byHandle[h] = fieldsList[i]; });
          var anyCustom = items.some(function (it) {
            var f = byHandle[it.handle];
            return isCustom(it.product_type, f && f.tags, '', [], [it.title, it.product_title]);
          });
          var anyPreOrder = items.some(function (it) { return isPreOrderItem(it.product_type, it.title); });
          // No measured timeline covers a pre-order (not even the custom "after you approve it"
          // wording, which does not account for a pre-order item in the same cart) - suppress
          // the promise whenever one is present, regardless of what else is in the cart.
          if (anyPreOrder) { hideCartShipDate(); return; }
          // The spec-pro pilot's own PDP trust row quotes a slower, measured, per-family line for
          // the 1/2" removable dots (78% within 2 business days, not 1) - a generic "ships by
          // tomorrow" promise for that same product in the cart/mini-cart would contradict what the
          // shopper just read on its product page. These 3 handles are the only ones with that
          // curated per-product data (see product-pages/README.md); this is deliberately a short,
          // explicit list rather than a general mechanism, since no other product on the site has
          // measured data this specific. See REPORT-buybox.md "Known limitations".
          var SLOWER_HANDLES = [
            '3-4-inch-color-code-sticky-dots',
            '2-wide-color-code-adhesive-dots',
            '1-2-removable-color-code-dots-1-000-roll'
          ];
          var anySlower = items.some(function (it) { return SLOWER_HANDLES.indexOf(it.handle) !== -1; });
          injectCartShipDate(
            anyCustom ? customMessage(today, holset) : stockMessage(today, holset, anySlower),
            anyCustom);
        });
      })
      .catch(function () {})
      .finally(function () {
        cartFetching = false;
        if (cartRefreshPending) { cartRefreshPending = false; refreshCart(today, holset); }
      });
  }

  function freshDateAndHolset() {
    var todayYMD = chicagoYMD(new Date());
    var today = utcDate(todayYMD.y, todayYMD.m, todayYMD.d);
    return { today: today, holset: holidaySetSpanning(today.getUTCFullYear(), today.getUTCFullYear() + 1) };
  }

  function run() {
    var dh = freshDateAndHolset();
    fillPdp(dh.today, dh.holset);
    refreshCart(dh.today, dh.holset);
  }

  // PDP-only re-check (ships-today countdown ticking down, a variant switch): deliberately does
  // NOT call refreshCart()/fetch `/cart.js`. This runs far more often (every 30s, plus on every
  // product-form input) than the cart ever needs to be re-read, and doing so unconditionally was
  // adding a cart request every 30 seconds on every single page (any page with the mini-cart
  // present, i.e. all of them) even with zero eligible variants - caught in Codex review.
  function runPdpOnly() {
    var dh = freshDateAndHolset();
    fillPdp(dh.today, dh.holset);
  }

  function debounced() {
    clearTimeout(window.__clShipDateTimer);
    window.__clShipDateTimer = setTimeout(run, 150);
  }
  function debouncedPdpOnly() {
    clearTimeout(window.__clShipDatePdpTimer);
    window.__clShipDatePdpTimer = setTimeout(runPdpOnly, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  window.addEventListener('pageshow', run);
  document.addEventListener('cart:updated', debounced);
  document.addEventListener('product:added', debounced); // fired by assets/gem-ajax-cart.js
  document.addEventListener('cart:refresh', debounced);

  // Add-to-cart clicks open the mini-cart drawer asynchronously; re-check shortly after one.
  // (This one legitimately needs the full run(), not the PDP-only path - the cart just changed.)
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest(
      'button[name="add"], [data-action="add-to-cart"], .cls-atc, .gf_add-to-cart');
    if (t) debounced();
  }, true);

  // Ships-today countdown (job 2026-10-07): re-check when the selected variant changes - a real
  // <select> fires 'change', spec-pro's swatch click and most custom pickers fire 'input' on the
  // hidden id field if they dispatch anything at all; some set .value with no event whatsoever, so
  // a 'click' anywhere inside a product form is also treated as "might have changed the variant"
  // (cheap and debounced; setText()'s equality guard makes a same-value re-check a no-op). None of
  // these touch the cart, so they use the PDP-only path.
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('form[action*="/cart/add"]')) debouncedPdpOnly();
  }, true);
  document.addEventListener('input', function (e) {
    if (e.target && e.target.closest && e.target.closest('form[action*="/cart/add"]')) debouncedPdpOnly();
  }, true);
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('form[action*="/cart/add"] .cls-sw, form[action*="/cart/add"] [class*="swatch" i], form[action*="/cart/add"] [class*="variant" i]')) debouncedPdpOnly();
  }, true);
  // Belt-and-suspenders: the countdown's remaining time changes every minute even with no variant
  // change at all, and some variant-selector JS neither fires an event nor mutates an attribute we
  // could observe. A 30s poll of the PDP only (no cart fetch) is cheap - one DOM read plus the same
  // idempotent, equality-guarded render path as everything else in this file - and guarantees the
  // countdown never goes stale by more than half a minute, on any template. Skips entirely when
  // there is no product payload on the page at all (most pages), so this is a no-op almost
  // everywhere, not just cart-request-free.
  setInterval(function () { if (window.__clShipDateMap) debouncedPdpOnly(); }, 30000);

  // Scoped (not document.body-wide) observers for the two cart surfaces, so unrelated widget/app
  // DOM churn elsewhere on the page can't keep re-triggering a /cart.js fetch.
  function observeCartRoot(root) {
    if (!root || root.__clObserved) return;
    root.__clObserved = true;
    new MutationObserver(debounced).observe(root, { childList: true, subtree: true });
  }
  observeCartRoot(document.getElementById('mini-cart'));
  document.querySelectorAll('.cart-recap, form[action$="/cart"]').forEach(observeCartRoot);
  // Both the mini-cart drawer AND the full cart page's form/.cart-recap can be swapped wholesale -
  // not just updated in place - by the theme's own ajax-cart script or Shopify's section-rendering
  // API (a quantity change or line removal commonly re-renders the whole section). That detaches
  // whatever MutationObserver was watching the OLD node, silently dropping the ship-date line and
  // its reactivity. Watch the rest of the page (cheap: this callback only inspects each mutation's
  // addedNodes list, it does not re-run on every attribute change) for a replacement matching
  // either surface and re-observe + refresh when one appears.
  function containsCartSurface(n) {
    if (n.nodeType !== 1) return false;
    if (n.id === 'mini-cart' || n.matches('.cart-recap, form[action$="/cart"]')) return true;
    return !!(n.querySelector && n.querySelector('#mini-cart, .cart-recap, form[action$="/cart"]'));
  }
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      for (var j = 0; j < muts[i].addedNodes.length; j++) {
        if (containsCartSurface(muts[i].addedNodes[j])) {
          observeCartRoot(document.getElementById('mini-cart'));
          document.querySelectorAll('.cart-recap, form[action$="/cart"]').forEach(observeCartRoot);
          debounced();
          return;
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
